import newsApi from '@/utils/news-api'
export default {
    uploadNewArticleImage(formData) {
        return newsApi.uploadFile('image/article/upload', formData)
    },
    getImageById(id) {
        return newsApi.get(`image?id=${id}`)
    },
    editImageById(id, formData) {
        return newsApi.post(`image/${id}/edit`, formData)
    },
    deleteImageById(id) {
        return newsApi.delete(`image/${id}`)
    },
    uploadNewNewspaperImage(formData) {
        return newsApi.uploadFile('image/newspaper/upload', formData)
    }
}
